import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-booking-day-count-config',
  templateUrl: './booking-day-count-config.component.html',
  styleUrls: ['./booking-day-count-config.component.css']
})
export class BookingDayCountConfigComponent implements OnInit {


  public isEdit: boolean = false;
  public seatConfigID: any;
  public formSubmitted: boolean = false;
  public formObject: any = {
    bookingDays:'multiple',
    dayCount:1,
  }
  public errorObject: any = {};
  public mailConfigData: any = {};

  constructor(private api: ApiService, private swal: SweetAlert) { }


  ngOnInit(): void {
    this.getBookingDayConfigData()
  }

  getBookingDayConfigData() {
    this.api.transportManagerGblSetBookingDayConfigList({}).then((res: any) => {
      if (res && res.status == 'success') {
        if(res.data && res.data[0]){
          this.isEdit = true;
          this.patchValue(res.data[0])
        }
      }
    }).catch((err) => {
      console.log('error', err);
    })
  }

  patchValue(obj) {
    this.formObject['dayCount'] = obj.dayCount ? obj.dayCount : 1;
    this.seatConfigID = obj['seatConfigID'];
  }


  fieldChange(field, event) {
    let value = event.target.value;
    if (this.formSubmitted) this.validation();
  }

  validation() {
    let isValid = true;
    this.errorObject = {};
    if (this.formObject.dayCount == '') {
      this.errorObject['dayCount'] = 'Day count is required.'
      isValid = false;
    }else if(this.formObject.dayCount < 0 || this.formObject.dayCount > 10){
      this.errorObject['dayCount'] = 'Day count range shoule be 1 to 10.'
      isValid = false;
    }
    return isValid;
  }

  onSubmit() {
    this.formSubmitted = true;
    let isValid = this.validation();
    if (isValid) {
      let obj = {
        bookingDays:'multiple',
        dayCount:this.formObject.dayCount,
      };
      let apiMethod = "transportManagerGblSetBookingDayConfigCreate";
      if (this.isEdit) {
        apiMethod = "transportManagerGblSetBookingDayConfigUpdate";
        obj['seatConfigID'] = this.seatConfigID;
      }
      this.api[apiMethod](obj).then((res) => {
        if (res.status == 'success') {
          this.getBookingDayConfigData();
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }

      }).catch((err) => {
        console.log('error', err);
      })
      console.log('finalObj', obj);
    }
  }
}
